import { shallow } from '@liveblocks/react';
import type React from 'react';
import styles from './FollowingOverlay.module.scss';
import useAuthStore from '../../hooks/auth';
import { getUserColorFromId, getTextColor } from '@fabric-app/utils/color';
import { CloseIcon } from '@fabric-app/icons/icons';
import {
  useBroadcastSpaceEvent,
  useSpaceOthers,
  useSpaceSelf,
  useUpdateSpacePresence,
} from '@fabric-app/business/multiplayer/config/spaces.config';

const FollowingOverlay: React.FC = () => {
  const user = useAuthStore((state) => state.user, shallow);
  const updateListPresence = useUpdateSpacePresence();
  const broadcastListEvent = useBroadcastSpaceEvent();
  const anonId = useSpaceSelf((me) => me.id, shallow);
  const following = useSpaceSelf((me) => me.presence.following, shallow);
  const followingUser = useSpaceOthers((others) => others.find((o) => o.id === following), shallow);
  const followingMeAmount = useSpaceOthers(
    (others) =>
      others.filter((o) => o.presence.following === user?.id || o.presence.following === anonId)
        .length,
    shallow,
  );

  const followingMeFirstId = useSpaceOthers(
    (others) =>
      others.find((o) => o.presence.following === user?.id || o.presence.following === anonId)?.id,
    shallow,
  );

  const color = followingUser
    ? getUserColorFromId(followingUser.id)
    : getUserColorFromId(followingMeFirstId ?? '');

  const clearSpotlight = () => {
    if (followingUser) {
      updateListPresence({
        following: null,
      });
    } else if (followingMeAmount > 0) {
      broadcastListEvent({
        type: 'clearSpotlight',
      });
    }
  };

  return followingUser || followingMeAmount > 0 ? (
    <>
      <div
        className={styles.overlay}
        style={{
          borderColor: color,
        }}
      />
      <div
        className={styles.box}
        style={{
          backgroundColor: color,
          color: getTextColor(color),
        }}
      >
        <span className={styles.title}>
          {followingUser ? 'Following' : `${followingMeAmount} following`}
        </span>
        {followingUser && <span className={styles.name}>{followingUser.info.name}</span>}
        <button className={styles.button} onClick={clearSpotlight}>
          <CloseIcon />
        </button>
      </div>
    </>
  ) : null;
};

export default FollowingOverlay;
